import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/services/it/appdev/page.tsx");
